export default __webpack_public_path__ + "static/edit-table-columns-9b58565725094d1814ac7cade82ee604.mp4";